import _jsx from "@babel/runtime/helpers/jsx";
var _span;
import PropTypes from 'prop-types';
import React from 'react';
import { Popup } from 'reaxl';

/**
 *  The VisitorsAgreement component is wrapped in a Popup component and takes a url string and passthrough props
 *
 */
function VisitorsAgreement(_ref) {
  let {
    url,
    text = 'By using this service, you accept the terms of our ',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "visitorsAgreement"
  }, rest), /*#__PURE__*/_jsx("span", {}, void 0, text), /*#__PURE__*/_jsx(Popup, {
    height: 590,
    width: 650,
    url: url
  }, void 0, _span || (_span = /*#__PURE__*/_jsx("span", {
    className: "text-link"
  }, void 0, "Visitor Agreement"))));
}
export default VisitorsAgreement;